import { useState, useRef, useEffect } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

function DropdownSelect({
    items = [],
    value = "",
    onChange,
    placeholder = "Välj",
    name = ""
}) {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const getItemValue = (item) => {
        return item?.seasonId ?? item?.id ?? item?.value ?? "";
    };

    const getItemLabel = (item) => {
        return (
            item?.seasonName ??
            item?.name ??
            item?.label ??
            item?.value ??
            `${item?.firstName ?? ""} ${item?.lastName ?? ""}`.trim()
        );
    };

    const selectedItem = items.find((item) => getItemValue(item) === value);

    const toggleDropdown = () => {
        setIsOpen((prev) => !prev);
    };

    const closeDropdown = () => {
        setIsOpen(false);
    };

    const handleSelect = (item) => {
        onChange?.(item);
        closeDropdown();
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                closeDropdown();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className="dropdown-select" ref={dropdownRef}>
            <button
                type="button"
                className={`dropdown-select--toggle ${isOpen ? "open" : ""}`}
                onClick={toggleDropdown}
            >
                <span className="dropdown-select--value">
                    {selectedItem ? getItemLabel(selectedItem) : placeholder}
                </span>

                <span className="dropdown-select--icon">
                    {isOpen ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                </span>
            </button>

            <div className={`dropdown-select--menu ${isOpen ? "open" : ""}`}>
                {items.map((item) => {
                    const itemValue = getItemValue(item);
                    const itemLabel = getItemLabel(item);
                    const isSelected = itemValue === value;

                    return (
                        <button
                            type="button"
                            key={itemValue}
                            className={`dropdown-select--item ${isSelected ? "selected" : ""}`}
                            onClick={() => handleSelect(item)}
                            name={name}
                        >
                            {itemLabel}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}

export default DropdownSelect;